const positions = ['absolute', 'fixed', 'sticky', 'relative']
const getAttribute = (el, attr) => el.getAttribute(attr) || el.getAttribute(`element-${attr}`)

const onMounted = (el, binding) => {
  const enabled = binding.value

  if (enabled === true) {
    const style = getComputedStyle(el)

    if (!positions.includes(style.position)) {
      el.classList.add('loading-parent')
    }

    if (el.loadingMask) {
      el.loadingMask.remove()
      delete el['loadingMask']
    }

    const elm = document.createElement('div')
    elm.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="25 25 50 50">
      <circle cx="50" cy="50" r="20" fill="none"/>
    </svg>`

    el.loadingMask = elm

    elm.style.background = getAttribute(el, 'loading-background')
    elm.classList.add('loading-mask')
    el.appendChild(elm)

    elm.style.opacity = '1'
  }
}

const onUnmounted = (el) => {
  if (el.loadingMask) {
    el.loadingMask.style.opacity = '0'

    setTimeout(() => {
      if (el.loadingMask) {
        el.loadingMask.remove()
        delete el['loadingMask']
      }

      el.classList.remove('loading-parent')
    }, 300)
  }
}

const onUpdated = (el, binding, vnode) => {
  const { value, oldValue } = binding

  if (value !== oldValue) {
    if (value === true) {
      onMounted(el, binding, vnode)
    } else {
      onUnmounted(el, binding, vnode)
    }
  }
}

const Plugin = {
  install(Vue) {
    if (Vue.prototype.$isServer) return

    Vue.directive('loading', {
      bind: onMounted,
      update: onUpdated,
      unbind: onUnmounted
    })
  }
}

export default Plugin
